import styled, { css } from "react-emotion";
import { breakpoints as bp, spacing as sp } from "../theme/layout";
import { spaces } from "../theme/layout/spacing";
/** Layout */
export const GenericPage = styled("div") `
  box-sizing: border-box;
  max-width: 90em;
  margin: 0 auto;
  ${sp.ph2};
  ${sp.pt3};

  & > h1,
  & > h2,
  & > h3,
  & > h4 {
    ${sp.mb1};
    ${sp.mh0};
    ${sp.mt0};
  }

  & > p,
  & > ul,
  & > ol,
  & > dl,
  & > table,
  & > div {
    ${sp.mb3};
    ${sp.mh0};
    ${sp.mt0};
  }

  & > p + p,
  & > p + ul,
  & > p + ol,
  & > p + dl,
  & > p + table,
  & > p + div,
  & > ul + p,
  & > ul + ul,
  & > ul + ol,
  & > ul + dl,
  & > ul + table,
  & > ul + div,
  & > ol + p,
  & > ol + ul,
  & > ol + ol,
  & > ol + dl,
  & > ol + table,
  & > ol + div,
  & > dl + p,
  & > dl + ul,
  & > dl + ol,
  & > dl + dl,
  & > dl + table,
  & > dl + div,
  & > table + p,
  & > table + ul,
  & > table + ol,
  & > table + dl,
  & > table + table,
  & > table + div,
  & > div + p,
  & > div + ul,
  & > div + ol,
  & > div + dl,
  & > div + table,
  & > div + div {
    margin-top: -${spaces[2]}px;
  }

  ${bp.medium `
    ${sp.ph3};
    ${sp.pt4};

    & > h1,
    & > h2,
    & > h3,
    & > h4 {
      ${sp.mb2}; ${sp.mh0};${sp.mt0};
    }

    & > p,
    & > ul,
    & > ol,
    & > dl,
    & > table,
    & > div  {
      ${sp.mb4}; ${sp.mh0};${sp.mt0};
    }

    & > p + p,
    & > p + ul,
    & > p + ol,
    & > p + dl,
    & > p + table,
    & > p + div,
    & > ul + p,
    & > ul + ul,
    & > ul + ol,
    & > ul + dl,
    & > ul + table,
    & > ul + div,
    & > ol + p,
    & > ol + ul,
    & > ol + ol,
    & > ol + dl,
    & > ol + table,
    & > ol + div,
    & > dl + p,
    & > dl + ul,
    & > dl + ol,
    & > dl + dl,
    & > dl + table,
    & > dl + div,
    & > table + p,
    & > table + ul,
    & > table + ol,
    & > table + dl,
    & > table + table,
    & > table + div,
    & > div + p,
    & > div + ul,
    & > div + ol,
    & > div + dl,
    & > div + table,
    & > div + div {
      margin-top: -${spaces[3]}px
    }
  `};

  table {
    ${sp.ma0};
  }

  ${props => props.textOnly
    ? css `
          ${bp.large `
            padding-right: 15em;
          `};
          ${bp.xlarge `
            padding-right: 30em;
          `};
        `
    : ""};
`;



// WEBPACK FOOTER //
// ./src/components/GenericPage.tsx